import React from '../assets/articles/should-we-learn-reactjs.png'
import Java from '../assets/articles/How-Java-Has-Advanced-In-The-Past-5-Years.jpg'
import DesignDev from '../assets/articles/design_dev.png'
import SeeMore from '../assets/articles/wp6411971.jpg'
import CI_CD_CD from '../assets/articles/CI_CD.jpg'

const articles = [
    {
        id: 1 ,
        background: Java,
        title:"Java Evolution In The Past 6 Years - From Java 8 to Java 15" ,
        link :"https://dev.to/wejdi_gh/how-java-has-advanced-in-the-past-6-years-from-java-8-to-java-15-4gj3"
    },
    {
        id: 5 ,
        background: CI_CD_CD,
        title:"The Difference Between Continuous Integration, Deployment and Delivery" ,
        link :"https://dev.to/wejdi_gh/the-difference-between-continuous-integration-deployment-and-delivery-2kia"
    },
    {
        id: 2 ,
        background : DesignDev ,
        title:"Web Development - From Design to Code",
        link :"https://dev.to/wejdi_gh/web-development-from-design-to-code-5b33"
    },
    {
        id: 3 ,
        background : React ,
        title:"Why Should I Learn ReactJS ?" ,
        link :"https://dev.to/wejdi_gh/why-should-i-learn-reactjs-cf5"
    },
    {
        id: 4 ,
        background : SeeMore ,
        title:"See More ...",
        link :"https://dev.to/wejdi_gh"
    },
    
]

export default articles